import React from 'react';

import styled from '@emotion/styled';

import saveTime from '@images_responsive/www/checkout/save_time.jpg';
import spaceYouUse from '@images_responsive/www/checkout/storage_hourly_rate.jpg';
import spaceYouUseCropped from '@images_responsive/www/checkout/storage_hourly_rate_cropped.jpg';
import storeAlmostAnything from '@images_responsive/www/checkout/store_almost_anything.jpg';

import { AccessItems } from './access_items';
import { ImageAndTextFeature } from './image_and_text_feature';
import { QualityServices } from './quality_services';
import { TraditionalStorageComparison } from './traditional_storage_comparison';

const List = styled.ul`
  list-style-type: disc;
  margin-left: 36px;
`;

export const SMART_STORAGE_FEATURES = [
  <ImageAndTextFeature
    key="0"
    title="Save time and money"
    content={
      <>
        Moving your items into traditional self-storage costs you a lot of time,
        stress, and money (on average more than $800). With Clutter Smart
        Storage, you save on all three.
        <br />
        <br />
        Every Smart Storage plan comes with free unlimited packing materials and
        discounted rates on moving. Finish your storage project on-budget with
        the help of our Move & Pack Specialists that are evaluated every day on
        safety and efficiency.
        <br />
        <br />
        And to save extra money on your project, you can opt to pack boxes
        yourself and we’ll just handle the heavy lifting.
      </>
    }
    image={saveTime}
  />,
  <ImageAndTextFeature
    key="1"
    title="Only pay for the space you use"
    content={
      <>
        With a traditional self-storage unit, you have to pay for the extra
        space that you’re not using.
        <br />
        <br />
        Clutter’s Move & Pack Specialists use an app that measures every item
        and you’ll only pay for the space your items take up. If you need less
        storage on the day of your pickup, we will automatically downgrade you
        to a smaller, cheaper plan.
        <br />
        <br />
        As you add or remove items from storage, you can flex your plan size and
        price based on the space you need.
      </>
    }
    image={spaceYouUse}
    croppedImage={spaceYouUseCropped}
  />,
  <QualityServices key="2" />,
  <AccessItems key="3" />,
  <ImageAndTextFeature
    key="4"
    title="Store almost anything"
    content={
      <>
        We’ve designed our Smart Storage facilities to safely store almost any
        type of item regardless of size or shape. Our special handling for
        categories like furniture, rugs, and bulky items allows us to eliminate
        common forms of damages.
        <br />
        <br />
        There are only a few things we can’t store: <br />
        <List>
          <li>Living items or food</li>
          <li>Vehicles or combustibles</li>
          <li>Grand pianos</li>
          <li>All-in-one home gyms</li>
        </List>
        <br />
        Anything else, send our way!
      </>
    }
    image={storeAlmostAnything}
  />,
  <TraditionalStorageComparison key="5" />,
];

export const SMART_STORAGE_COMMITMENT_FEATURES = [
  <ImageAndTextFeature
    key="0"
    title="How Appointments Work"
    content={
      <>
        Clutter always provides the first pickup to move your items into storage
        and the last delivery to move your items out of storage. This is
        included in the cost of your storage subscription.
        <br />
        <br />
        You can also have stored items delivered right to your door and send new
        ones back into storage — quick and easy!
        <br />
        <br />
        If you store for 4 months, then you get one of those appointments for
        free. If you store for at least 8 months, then you can get four of those
        appointments for free.
      </>
    }
    image={saveTime}
  />,
  <QualityServices key="1" />,
];
